import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Clock, CreditCard, Check } from 'lucide-react';

export default function TrialExpired() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center px-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="pt-8 pb-8">
          <div className="text-center space-y-6">
            {/* Icon */}
            <div className="mx-auto w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
              <Clock className="w-12 h-12 text-orange-600" />
            </div>

            {/* Message */}
            <div>
              <h1 className="text-3xl font-bold mb-3">Your Free Trial Has Ended</h1>
              <p className="text-lg text-gray-600 mb-6">
                Thank you for trying StenoU! Your 7-day free trial has expired.
              </p>
            </div>

            {/* Features Reminder */}
            <div className="bg-gray-50 rounded-lg p-6 text-left">
              <h3 className="font-semibold mb-4 text-center">Continue Your Journey with Full Access:</h3>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span>Access to all court reporting lessons</span>
                </li>
                <li className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span>Audio practice files at various speeds</span>
                </li>
                <li className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span>Progress tracking and exercise completion</span>
                </li>
                <li className="flex items-center gap-3">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0" />
                  <span>Personal notes and reminders</span>
                </li>
              </ul>
            </div>

            {/* Pricing Quick View */}
            <div className="grid md:grid-cols-2 gap-4">
              <div className="border-2 border-gray-200 rounded-lg p-4">
                <Badge variant="outline" className="mb-2">Monthly</Badge>
                <div className="text-2xl font-bold mb-1">$10<span className="text-sm text-gray-500">/month</span></div>
                <p className="text-xs text-gray-600">Cancel anytime</p>
              </div>
              <div className="border-2 border-green-500 rounded-lg p-4">
                <Badge className="bg-green-600 mb-2">Best Value - Save $20</Badge>
                <div className="text-2xl font-bold mb-1">$100<span className="text-sm text-gray-500">/year</span></div>
                <p className="text-xs text-gray-600">Save 17% annually</p>
              </div>
            </div>

            {/* CTA */}
            <Button
              onClick={() => navigate('/subscribe')}
              size="lg"
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-lg py-6"
            >
              <CreditCard className="w-5 h-5 mr-2" />
              Subscribe Now to Continue Learning
            </Button>

            <p className="text-sm text-gray-500">
              Secure payment processed by Stripe
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
